import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterIsCertifiedSearchValueObject extends ValueObject {
  #isCertified

  constructor({isCertified}) {
    super()
    this.#isCertified = isCertified
  }

  static create({isCertified}) {
    return new FilterIsCertifiedSearchValueObject({isCertified: FilterBooleanSearchValueObject.create(isCertified)})
  }

  static createWithDefaultValue({config, isCertified}) {
    const {DEFAULT_IS_CERTIFIED_SEARCH} = config.get('searchFilters')

    return new FilterIsCertifiedSearchValueObject({
      isCertified: FilterBooleanSearchValueObject.create({boolean: isCertified ?? DEFAULT_IS_CERTIFIED_SEARCH})
    })
  }

  static createQueryParams({config, isCertified}) {
    const {DEFAULT_IS_CERTIFIED_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterIsCertifiedSearchValueObject({
      isCertified: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.IS_CERTIFIED],
        value: isCertified === DEFAULT_IS_CERTIFIED_SEARCH ? null : isCertified
      })
    })
  }

  get isEmpty() {
    return this.#isCertified.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#isCertified.queryParam})
    }
  }

  get value() {
    return this.#isCertified.value
  }

  toJSON() {
    return {
      isCertified: this.#isCertified.toJSON()
    }
  }
}
